/**
 * Проксирует внешние URL через сервер.
 * Локальные пути (/uploads/...) остаются как есть.
 */
export default function proxyUrl(url) {
  if (!url) return "";
  if (url.startsWith("/") || url.startsWith("data:") || url.startsWith("blob:"))
    return url;
  return `/api/image-proxy?url=${encodeURIComponent(url)}`;
}
